export default __webpack_public_path__ + "static/media/logo.f3f7ec2a.svg";